import { getErrors, extractErrorMessage, mapValueProperties } from '@/utilities/common'
import auth from '@/utilities/udi/udi.js'
import { detectedCulture } from 'utilities/common/culture'
import Vue from 'vue'
import { cloneDeep, assign, omit } from 'lodash'
import { mapState } from 'vuex'

export default {
  props: {
    personalDetail: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      prePersonalDetail: cloneDeep(this.personalDetail),
      editable: false,
      showValidations: false,
      routeName: this.$route.name,
      bundleName: this.$route.query.bundle || null,
      countryCode: detectedCulture.countryCode,
      isShow: false
    }
  },

  computed: {
    ...mapState('account', {
       
      sbeCompliance: state => state.profile.personalDetail.sbeCompliance
    }),

    ...mapValueProperties('personalDetail', [
      'firstName',
      'lastName',
      'email',
      'phoneNumber',
      'selectedNewsletter'
    ])
  },

  methods: {
    errorsFor (field) {
      if (!this.showValidations) {
        return []
      }

      if (this.$v[field] == null) {
        return []
      }

      return getErrors(this.$v[field])
    },

    editPersonalDetail () {
      this.trackConversion({ name: 'interaction', description: `personal_details:edit:${this.editable ? 'edit' : 'cancel'}` })
      if (!this.editable) {
        this.showValidations = true
        this.editable = true
        this.prePersonalDetail = cloneDeep(this.personalDetail)
        this.isShow = true
      } else {
        this.$store.commit('account/setPersonalDetail', this.prePersonalDetail)
        this.editable = false
        this.isShow = false
      }
    }
  },

  tasks (t) {
    return {
      updatePersonalDetailTask: t(async function () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          setTimeout(() => {
            this.$scrollTo('[data-scroll="personalDetail"] .error', {
              offset: -130
            })
          }, 10)
          if (/checkout/i.test(this.routeName)) {
            this.trackErrorFormFields()
          }
        } else {
          this.trackConversion({ name: 'interaction', description: 'personal_details:next' })
          if (this.countryCode === 'PL') {
            this.personalDetail.phoneNumber = this.phoneNumber.replace(/\D/g, '')
          }
          await Vue.api.account.updatePersonalDetail(this.personalDetail, this.bundleName, this.bundles, this.sbeCompliance)
          const accessToken = await auth.getToken()
          if (accessToken) {
            try {
              await Vue.api.account.updateOptIn({ accessToken, optIn: this.personalDetail.selectedNewsletter })
            } catch (e) {
            }
          }
          window.sessionStorage.setItem('personalDetail', JSON.stringify(assign({}, JSON.parse(window.sessionStorage.getItem('personalDetail')), omit(this.personalDetail, ['initialPhoneNumbe']))))
          this.editable = false
          this.$notify({
            type: 'success',
            title: this.$t('popuptips.personalDetail.update.successful', 'personal detail updated successfully')
          })
          if (/checkout/i.test(this.routeName)) {
            this.additionalActions()
          }
          this.isShow = false
        }
      }).onError(function (task) {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(task.error)
        })
        this.$scrollTo('[data-scroll="personalDetail"]', {
          offset: -60
        })
      }).flow('drop')
    }
  }
}
